import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import USER_QUERY from 'components/MainLayout/graphql/userQuery.gql';

import OffersHome from './Offers/Loadable';
// import Home from './Loadable';

class Switch extends React.PureComponent {
  render() {
    const { userQuery } = this.props;
    const currentUser = userQuery && userQuery.user ? userQuery.user : false;

    if (currentUser) {
      return <OffersHome {...this.props} />;
    }

    return null;
  }
}

const IS_TOKEN = gql`
  query IsToken {
    isToken
  }
`;

export default compose(
  graphql(IS_TOKEN, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { isToken } }) => ({
      isToken,
    }),
  }),
  graphql(USER_QUERY, {
    name: 'userQuery',
    skip: (ownProps) => !ownProps.isToken,
  })
)(Switch);



// WEBPACK FOOTER //
// ./app/containers/HomePage/Switch.js